export const GROUP_FIELD_FETCH_REQUEST = 'GROUP_FIELD_FETCH_REQUEST';
export const GROUP_FIELD_FETCH = 'GROUP_FIELD_FETCH';

export const GROUP_FIELD_UPDATE_REQUEST = 'GROUP_FIELD_UPDATE_REQUEST';
export const GROUP_FIELD_UPDATE = 'GROUP_FIELD_UPDATE';

export const GROUP_FIELD_DELETE_REQUEST = 'GROUP_FIELD_DELETE_REQUEST';
export const GROUP_FIELD_DELETE = 'GROUP_FIELD_DELETE';
